export default "__VITE_ASSET__c84246b6__"